import VueRouter from 'vue-router';

import MainApp from '@/components/app/MainApp';

import adminRoutes from './admin';
import analyticsRoutes from './analytics';
import audienceRoutes from './audience';
import authRoutes from './auth';
import campaignRoutes from './campaign';
import dashboardRoutes from './dashboard';
import fileboxRoutes from './filebox';
import interactionRoutes from './interaction';
import channelRoutes from './channel';
import companyRoutes from './company';
import profileRoutes from './profile';
import rulesRoutes from './rules';
import socialRoutes from './social';
import surveyRoutes from './surveys';
import surveyBuilderRoutes from './surveybuilder';

const routes = [
  ...authRoutes,
  {
    path: '/app',
    component: MainApp,
    children: [
      ...adminRoutes,
      ...analyticsRoutes,
      ...audienceRoutes,
      ...campaignRoutes,
      ...dashboardRoutes,
      ...fileboxRoutes,
      ...interactionRoutes,
      ...channelRoutes,
      ...companyRoutes,
      ...profileRoutes,
      ...socialRoutes,
      ...rulesRoutes,
      ...surveyRoutes,
      ...surveyBuilderRoutes,
    ],
  },
  { path: '*', redirect: '/' },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('token')) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js